import initialState from './initial-state';
import { createReducer } from './reducer-creator';

const SetOfertaOriginal = (initialState, action) => {
  return {
    ...initialState,
    original: action.payload,
  };
};

const SetOfertaFiltrados = (initialState, action) => {
  return {
    ...initialState,
    filtrados: action.payload,
  };
};

export default createReducer(initialState.offers, {
  SET_OFFERS_FILTRADOS: SetOfertaFiltrados,
  SET_OFFERS_ORIGINAL: SetOfertaOriginal,
});
